module.exports = __webpack_public_path__ + "img/DonationSummaryBGDesktop.584fee1e.svg";